import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './RegInfo.module.css';

import { useSlice } from '../../../../hooks/useSlice';
import { useAppSelector } from '../../../../hooks/useRedux';

import { Library } from '../../../../types/library';
import Item from '../Item';
import Input from '../../../Input';

import {
  ENTER_FILE_NAME,
  ENTER_PWD,
  ENTER_SHARED_URL,
  ENTER_URL,
  FILE_NAME,
  LINK_NAME,
  PWD,
} from '../../../../constants';
import { isOfType } from '../../../../utils/typeGuard';

interface RegInfo {
  id: string;
  onChange: () => void;
  message: string;
  data?: string;
  subKey?: string;
}

interface Props {
  [key: string]: { name: string; label: string; placeholder?: string }[];
}

export default function RegInfo({
  id,
  onChange,
  message,
  data: pwdYn,
  subKey,
}: RegInfo) {
  const cx = classNames.bind(styles);
  const { selectSingleItem } = useSlice();
  const item = useAppSelector(selectSingleItem);
  const [hasProfanity, setHasProfanity] = useState(false);

  const propsById: Props = {
    linkRegistration: [
      { name: 'link', label: 'URL', placeholder: ENTER_SHARED_URL },
      ...(pwdYn ? [{ name: 'pwd', label: PWD, placeholder: ENTER_PWD }] : []),
    ],
    linkPassword: [{ name: 'pwd', label: PWD, placeholder: ENTER_PWD }],
    dataRegistration: [
      { name: 'name', label: LINK_NAME, placeholder: ENTER_FILE_NAME },
      { name: 'url', label: 'URL', placeholder: ENTER_URL },
    ],
    resource: [{ name: 'data', label: FILE_NAME }],
    url: [{ name: 'data', label: 'URL' }],
  };
  const props = propsById[id];

  const inpValue =
    id === 'resource'
      ? (isOfType(item, 'project') &&
          isOfType(item.project, 'orgFileName') &&
          item.project.orgFileName) ||
        (isOfType(item, 'resource') && item.resource.orgFileName)
      : id === 'url'
      ? isOfType(item, 'resource') &&
        isOfType(item.resource, 'url') &&
        item.resource.url
      : '';
  console.log('inpValue : ', inpValue);
  return (
    <>
      <Item id={id} innerClass="s_min">
        {props.map(({ name, label, placeholder }) => (
          <div key={name} className={cx('panel_row')}>
            <span className={cx('sub', { h48: message })}>{label}</span>
            <div className={cx('detail')}>
              <div
                className={cx(
                  'input_box',
                  {
                    lone:
                      (message && message.includes(label.toLowerCase())) ||
                      hasProfanity,
                  },
                  {
                    'input--error':
                      (message && message.includes(label.toLowerCase())) ||
                      hasProfanity,
                  }
                )}
              >
                <Input
                  type="text"
                  id={name}
                  placeholder={placeholder}
                  onChange={onChange}
                  value={inpValue}
                  subKey={subKey}
                  onValidate={(isValid) => setHasProfanity(!isValid)}
                />
                <span className={cx('msg')}>{message}</span>
              </div>
            </div>
          </div>
        ))}
      </Item>
    </>
  );
}
